export default "__VITE_PUBLIC_ASSET__70b0f7be__"